export const LOGIN_URL = ".well-known/openid-configuration";
export const APPAUTH_USERNAME_KEY = "appAuthUsernameKey";
export const APPAUTH_IAM_SETTINGS_KEY = "appAuthIamSettingsKey";

export enum AuthErrorCodes {
    SESSION_PARSE_FAILED = 'SESSION_PARSE_FAILED',
    SESSION_RETRIEVE_FAILED = 'SESSION_RETRIEVE_FAILED',
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
    NO_DATA_FOUND = 'NO_DATA_FOUND',
    INVALID_URL = 'INVALID_URL',
    INVALID_REDIRECT_SCHEME = 'INVALID_REDIRECT_SCHEME',
    FAILED_TO_SAVE_AUTH_STATE = 'FAILED_TO_SAVE_AUTH_STATE',
    USERNAME_MISMATCH = 'USERNAME_MISMATCH',
    NO_ACCESS_TOKEN_FOUND = 'NO_ACCESS_TOKEN_FOUND',
    PARSE_FAILED_FOR_AUTH_STATE = 'PARSE_FAILED_FOR_AUTH_STATE',
    TOKEN_REFRESH_FAILED = 'TOKEN_REFRESH_FAILED',
    TOKEN_REFRESH_REAUTH_REQUIRED = 'TOKEN_REFRESH_REAUTH_REQUIRED',
    MISSING_AUTH_DATA = 'MISSING_AUTH_DATA',
    NO_EXTERNAL_USER_AGENT = 'NO_EXTERNAL_USER_AGENT',
    REVOKE_TOKEN_FAILED = 'REVOKE_TOKEN_FAILED',
    UNEXPECTED_RESPONSE = 'UNEXPECTED_RESPONSE',
    NETWORK_ERROR = 'NETWORK_ERROR',
    USER_CANCELLED = 'USER_CANCELLED',
    OID_GENERAL_ERROR = 'OID_GENERAL_ERROR',
    OAUTH_AUTHORIZATION_ERROR = 'OAUTH_AUTHORIZATION_ERROR',
    OAUTH_TOKEN_ERROR = 'OAUTH_TOKEN_ERROR'
}